import styled from 'styled-components';


export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background: #FCFAFA;
    color: #032d34;
`;


export const Introduction = styled.section`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 7em 8vw 6em;
    background: #F1E3D4;

    @media (max-width: 800px) {
        padding: 5em 6vw 4em;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw 3.5em;
    }
`;


export const IntroductionText = styled.div`
    width: 100%;
    max-width: 850px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & > p {
        max-width: 750px;
    }
`;


export const Steps = styled.section`
    width: 100%;
    max-width: 950px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 6em 8vw;

    & > h2 {
        margin-bottom: 2em;
    }

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const Step = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1.5em;
    margin-bottom: 2.5em;

    &:last-child {
        margin-bottom: 0;
    }

    @media (max-width: 500px) {
        gap: 1em;
    }
`;


export const StepNumber = styled.div`
    flex: 0 0 2.5em;
    width: 2.5em;
    height: 2.5em;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    background: #145f68;
    color: #fff;

    font-size: 1em;
    font-weight: 600;
`;


export const StepContent = styled.div`
    flex: 1;

    & > h3 {
        margin-top: 0;
        margin-bottom: 0.4em;
        color: #145f68;
    }

    & > p {
        margin-top: 0;
    }
`;


export const CTA = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 5em 8vw;
    background: #E8F0EF;
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;

    & > p {
        max-width: 700px;
    }

    @media (max-width: 800px) {
        padding: 4em 6vw;
    }

    @media (max-width: 500px) {
        padding: 3.5em 5vw;
    }
`;


export const ParentNotice = styled.div`
    width: 100%;
    max-width: 750px;
    box-sizing: border-box;

    margin-top: 3em;
    padding: 1.5em 2em;

    background: #FCFAFA;
    border-radius: 4px;

    text-align: left;

    & p {
        margin: 0;
        font-size: 0.95em;
    }

    @media (max-width: 500px) {
        padding: 1.25em 1.25em;
    }
`;


export const ContactLink = styled.a`
    color: #145f68;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;

    &:hover {
        text-decoration-thickness: 2px;
    }
`;


export const FormSection = styled.section`
    width: 100%;
    max-width: 850px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 6em 8vw 8em;

    @media (max-width: 800px) {
        padding: 5em 6vw 6em;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw 5em;
    }
`;


export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.5em;
    margin-top: 3em;
`;


export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
`;


export const Label = styled.label`
    color: #032d34;
    font-weight: 600;
    font-size: 1em;
`;


export const Required = styled.span`
    color: #75391b;
`;


export const Optional = styled.span`
    font-weight: 400;
    font-size: 0.9em;
    opacity: 0.7;
`;


export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;

    padding: 0.85em 1em;

    border: 1px solid #c8cece;
    border-radius: 3px;

    background: #fff;
    color: #032d34;

    font-family: inherit;
    font-size: 1em;

    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;

    &:focus {
        outline: none;
        border-color: #145f68;
        box-shadow: 0 0 0 3px rgba(20, 95, 104, 0.12);
    }

    &::placeholder {
        color: #777;
        opacity: 0.7;
    }
`;


export const Textarea = styled.textarea`
    width: 100%;
    min-height: 150px;
    box-sizing: border-box;

    padding: 0.85em 1em;

    border: 1px solid #c8cece;
    border-radius: 3px;

    background: #fff;
    color: #032d34;

    font-family: inherit;
    font-size: 1em;
    line-height: 1.5;

    resize: vertical;

    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;

    &:focus {
        outline: none;
        border-color: #145f68;
        box-shadow: 0 0 0 3px rgba(20, 95, 104, 0.12);
    }

    &::placeholder {
        color: #777;
        opacity: 0.7;
    }
`;


export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75em;
    margin-top: 0.25em;
`;


export const RadioOption = styled.label`
    display: flex;
    align-items: center;
    gap: 0.75em;

    cursor: pointer;

    font-weight: 400;

    & input {
        width: 1.1em;
        height: 1.1em;
        margin: 0;

        accent-color: #145f68;
        cursor: pointer;
    }
`;


export const Confirmation = styled.section`
    width: 100%;
    max-width: 750px;
    box-sizing: border-box;

    min-height: 60vh;
    margin: 0 auto;
    padding: 8em 8vw;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    & > h1 {
        color: #145f68;
    }

    & > p {
        max-width: 700px;
    }

    @media (max-width: 800px) {
        padding: 6em 6vw;
    }

    @media (max-width: 500px) {
        padding: 5em 5vw;
    }
`;


export const ErrorMessage = styled.div`
    padding: 1em 1.25em;

    border-radius: 3px;

    background: #f7e5e1;
    color: #75391b;

    font-size: 0.95em;
`;